module.exports = __webpack_public_path__ + "media/images/navbar/dropdown_menu/account-b10fb2c78ac0b8ff50ab6c8c8b84b718.svg";